import React from "react";
import { CompetitionAnalyzerPriceEvolutionProvider, CompetitionAnalyzerSubmittedFiltersProvider, CompetitionAnalyzerTableTypeProvider, CompetitionAnalyzerLocationDataProvider, CompetitionAnalyzerReportExecutionProvider } from "./@contexts";


export default function CompetitionAnalyzerProviders({ children }) {

    return <CompetitionAnalyzerReportExecutionProvider>
        <CompetitionAnalyzerSubmittedFiltersProvider>
            <CompetitionAnalyzerPriceEvolutionProvider>
                <CompetitionAnalyzerTableTypeProvider>
                    <CompetitionAnalyzerLocationDataProvider>
                        {children}
                    </CompetitionAnalyzerLocationDataProvider>
                </CompetitionAnalyzerTableTypeProvider>
            </CompetitionAnalyzerPriceEvolutionProvider>
        </CompetitionAnalyzerSubmittedFiltersProvider>
    </CompetitionAnalyzerReportExecutionProvider>
}

export { CompetitionAnalyzerSubmittedFiltersContext, CompetitionAnalyzerPriceEvolutionContext, CompetitionAnalyzerTableTypeContext, CompetitionAnalyzerLocationDataContext, CompetitionAnalyzerReportExecutionContext } from "./@contexts"